<template>
  <v-card class="align-stretch" height="100%">
    <v-card-title>
      Modem
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="editModemOpen=true"><v-icon small>edit</v-icon></v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" class="ml-2" x-small :href="queueUrl" target="_blank"><v-icon small>{{queueIcon}}</v-icon></v-btn>
        </template>
        <span>Hardware Ordering Queue</span>
      </v-tooltip>
    </v-card-title>

    <v-card-text>
      <v-row>       
        <v-col>
          <p class="mb-1 text-caption">Modem Username</p>
          <p><b>{{getTelcoProvisioning.modem_username | customPlaceholder}}</b></p>
          <p class="mb-1 text-caption">Modem Password</p>
          <p><b>{{getTelcoProvisioning.modem_password | customPlaceholder}}</b></p>
        </v-col>
      </v-row>
    </v-card-text>
    <ModemCredentialsDialog :dialogOpen="editModemOpen" @close-dialog="editModemOpen=false;" />
  </v-card>
</template>

<script>
  import { mdiFormatListText  } from '@mdi/js';
  import {mapState, mapGetters} from 'vuex';
  import ModemCredentialsDialog from "./ModemCredentialsDialog";

  export default {
    components: {ModemCredentialsDialog},

    data() {
      return {
        editModemOpen: false,
        queueIcon: mdiFormatListText,
        queue_url: process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`,
      }
    },

    computed: {
      ...mapState('products',['currentProduct']),
      ...mapGetters('productTelco',['getTelcoProvisioning']),
      queueUrl(){
        return `${this.queue_url}hardware-ordering/actions/?product_id=${this.currentProduct.id}`;
      },
    },
  }
</script>

<style>

</style>
